<template>
    <v-container fluid class="mt-6">
        <v-row v-if="!lead_id" class="d-flex align-center">
            <v-col class="d-flex align-center justify-space-between">
                <v-btn text @click="backToLeads()">
                    <div class="back-to-leads d-flex">
                        <v-img src="../../assets/back_arrow.svg" width="20" height="20" class="mr-2"></v-img>
                        Back to Lead
                    </div>
                </v-btn>
                <div class="d-flex align-center">
                    <v-btn-toggle v-model="mode" mandatory dense borderless class="mode-toggle">
                        <v-btn value="simple" small>Quick</v-btn>
                        <v-btn value="advanced" small>Advanced</v-btn>
                    </v-btn-toggle>
                    <v-btn text color="red" @click="deleteQuoteDialog()" v-if="edit_quote_id" class="ml-3">
                        Delete Quote
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-5" style="padding-left:24px;padding-right:24px;" v-if="lead && pageReady">
            <v-col cols="3">
                <v-text-field class="custom-text-field-active" v-model="quote_name" outlined round
                    label="QUOTE NAME *"></v-text-field>
            </v-col>
            <v-col>
                <v-text-field class="custom-text-field-active" v-model="groupsize" outlined round
                    label="QUOTE GROUP SIZE *"></v-text-field>
            </v-col>
            <v-col>
                <!-- The fewest people who must pay for this package: shown in the booking confirmation
                     email, flagged on the events lists when fewer have paid. See MINIMUM_GROUP_SIZE.md -->
                <v-text-field class="custom-text-field-active" v-model="min_groupsize" outlined round
                    type="number" min="1" label="MINIMUM GROUP SIZE" placeholder="None"
                    persistent-placeholder></v-text-field>
            </v-col>
            <v-col>
                <v-autocomplete class="custom-text-field-active" v-model="quote_location_id" :items="getLocations" outlined
                    round item-text="name" item-value="id" label="LOCATION" @change="onLocationChange"></v-autocomplete>
            </v-col>
            <v-col>
                <v-text-field class="custom-text-field" v-model="start_date" round label="LEAD START DATE"
                    readonly></v-text-field>
            </v-col>
            <v-col>
                <v-text-field class="custom-text-field" v-model="end_date" round label="LEAD END DATE"
                    readonly></v-text-field>
            </v-col>
            <v-col>
                <v-text-field class="custom-text-field" v-model="people" round label="LEAD GROUP SIZE"
                    readonly></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-skeleton-loader type="table" v-if="!pageReady"></v-skeleton-loader>
                <v-stepper v-else v-model="selected_step" alt-labels elevation="0">
                    <div class="stepper-hint">Click any step to jump to it — your progress will be saved automatically.</div>
                    <v-stepper-header>
                        <div v-for="(step, index) in steps" :key="index" class="custom-stepper-header">
                            <v-stepper-step :complete="selected_step > index + 1" :step="index + 1"
                                @click="index < steps.length - 1 ? changeStep(index) : null"
                                :style="index < steps.length - 1 ? 'cursor:pointer;' : 'cursor:default;'"
                                :color="(selected_step == index + 1) ? '#3988AA' : '#AFCFDC'">
                                <div
                                    :class="(selected_step == index + 1) ? 'custom-step-active' : 'custom-step-inactive'">
                                    {{ step }}
                                </div>
                            </v-stepper-step>
                            <v-divider v-if="index < steps.length - 1" color="#AFCFDC"></v-divider>
                        </div>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-row>
                            <v-col :cols="(selected_step < total_steps) ? 6 : 12" class="pr-9">
                                <v-stepper-content v-for="(step, index) in steps" :key="mode + '-' + index + '-' + draft_key" :step="index + 1">

                                    <v-skeleton-loader v-if="index == 0 && loading_location_change" type="article"></v-skeleton-loader>
                                    <Accommodation v-if="index == 0 && !loading_location_change" ref="accommodation" :lead="lead" :date_range="date_range"
                                        :suppliers="all_suppliers" :edit_build="builds[0]" @skip="skip()"
                                        @back="back()" @save="save" @saveWithoutScroll="saveWithoutScroll" />
                                    <!-- Accommodation has start and end date, and one auto-selected option per supplier -->

                                    <v-skeleton-loader v-if="index > 0 && index <= step_configs.length && loading_location_change" type="article"></v-skeleton-loader>
                                    <QuoteBuild v-if="index > 0 && index <= step_configs.length && !loading_location_change" ref="quoteBuild" :lead="lead" :date_range="date_range"
                                        :suppliers="all_suppliers" :service_name="step_configs[index - 1].service_name"
                                        :type_groups="step_configs[index - 1].type_groups"
                                        :booking_types="booking_types" :type_step_lookup="type_step_lookup"
                                        :edit_builds="edit_builds_by_step[index - 1]" :quote_location="selected_location" @skip="skip()"
                                        @back="back()" @save="save" @saveWithoutScroll="saveWithoutScroll" @moveOption="onMoveOption" />
                                    <!-- QuoteBuild encapsulates the rest of the supplier services, with only start date and multiple options -->

                                </v-stepper-content>
                                <Review ref="review" v-show="selected_step == review_step" :all_builds="builds" :edit_quote="quote_to_edit"
                                    :lead="lead" :quote_location="selected_location" :groupsize="groupsize" @back="back()" @finish="finish"
                                    @update="update" />

                                <Complete v-if="selected_step == total_steps" :lead="lead" :quote="created_quote"
                                    :quote_location="selected_location" @emailQuote="emailQuote()" />
                            </v-col>
                            <v-col v-if="selected_step < total_steps" cols="6" class="pl-9"
                                style="background-color:white;z-index:1;">
                                <div class="summary">SUMMARY</div>
                                <v-expansion-panels v-model="open_panels" multiple class="custom-expansion-panels">
                                    <v-expansion-panel v-for="(step, index) in sidebar_steps" :key="mode + '-side-' + index"
                                        class="custom-expansion-panel mb-7">
                                        <v-expansion-panel-header class="custom-expansion-header" :id="'panel' + index">
                                            {{ step }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="custom-expansion-panel-content">
                                            <SummaryContent v-if="index == 0" :accommodations="builds[0]" :step="index"
                                                @changeStep="changeStep" />
                                            <SummaryContent v-else :entries="sidebar_builds_by_step[index - 1]"
                                                :multi_type="step_configs[index - 1].type_groups.length > 1" :step="index"
                                                @changeStep="changeStep" />
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>

        <ConfirmDeleteQuote :delete_quote_dialog="delete_quote_dialog" :quote_id="edit_quote_id"
            @closeDeleteQuoteDialog="closeDeleteQuoteDialog()" @deleteQuote="deleteQuote()"></ConfirmDeleteQuote>
        <VariantChangesDialog ref="variantChanges" />
        <SupplierChangesPrompt :changes="supplier_changes" @close="closeSupplierChanges()" />
        <!-- After the supplier emails prompt, if any: the organiser paid the old (discounted) price -->
        <OrganiserDiscountPrompt :prompt="supplier_changes ? null : organiser_prompt" @close="organiser_prompt = null" />
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { lookups, loadLookups } from '@/common/companyLookups'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isBetween from 'dayjs/plugin/isBetween'

import SummaryContent from './modules/SummaryContent.vue'
import Accommodation from './modules/Accommodation.vue'
import QuoteBuild from './modules/QuoteBuild.vue'
import Review from './modules/Review.vue'
import Complete from './modules/Complete.vue'
import ConfirmDeleteQuote from './components/ConfirmDeleteQuote.vue'
import VariantChangesDialog from './components/VariantChangesDialog.vue'
import SupplierChangesPrompt from '../events/components/SupplierChangesPrompt.vue'
import OrganiserDiscountPrompt from '../events/components/OrganiserDiscountPrompt.vue'
export default {
    components: {
        SummaryContent, Accommodation, QuoteBuild, Review, Complete, ConfirmDeleteQuote, VariantChangesDialog,
        SupplierChangesPrompt,
        OrganiserDiscountPrompt
    },
    props: [
        'lead_id', 'quote_id'
    ],
    data: () => ({
        loaded: false,
        // From the API when a save or delete changed booked suppliers' bookings: offer them an email.
        supplier_changes: null,
        leave_after_supplier_changes: false,
        builds_ready: false,
        // Bumped when an AI Assistant draft is loaded, so the step components rebuild from it
        draft_key: 0,
        loading_location_change: false,
        edit_quote_id: null,
        // The API's organiser_paid_at_old_price after a save (OrganiserDiscountPrompt)
        organiser_prompt: null,
        quote_to_edit: null,
        delete_quote_dialog: false,
        quote_name: 'New Quote',
        groupsize: 0,
        min_groupsize: null,
        quote_location_id: null,
        classes: {
        },
        mode: 'simple',
        // Index = build_index (0-7). These describe the fixed mapping between a build's
        // position in `builds` and the supplier's service_type_id, regardless of UI mode.
        build_index_labels: ['Accommodation', 'Day Activity', 'Night Activity', 'Breakfast', 'Fingerfood', 'Dinner', 'Transport', 'Addons'],
        build_index_supplier_types: [1, 2, 6, 8, 4, 5, 3, 7],
        selected_step: 1,
        lead: {
            id: null,
            advisor_id: 0,
            duration: 1,
            activity_type: null,
            start_date: null,
            location_id: null,
            location: {
                name: null,
            },
            first_name: null,
            last_name: null,
            phone: null,
            email: null,
            password: null,
            people: 1,
            company_id: null
        },
        date_range: [],
        all_suppliers: [],
        open_panels: [0],
        builds: [],
        created_quote: null,
    }),
    async mounted() {
        await loadLookups('locations')
        await this.getLeadData()
        await this.getEditData()
        // Fetched once here, after both getLeadData() and getEditData() have settled on
        // the final quote_location_id, instead of once per call (which used to fetch the
        // same location's supplier list twice on every edit-quote load).
        await this.getSuppliers()
        // Populating builds only after suppliers are loaded lets Accommodation/QuoteBuild
        // resolve each build's supplier from the already-fetched list instead of each
        // firing its own get_supplier request.
        this.populateEditBuilds()
        // A quote the AI Assistant drafted for this page (see loadAiQuoteDraft)
        await this.$nextTick()
        this.loadAiQuoteDraft()
    },
    created() {
        this.$date.extend(advancedFormat)
        this.$date.extend(isBetween)
    },
    computed: {
        getLocations() {
            return lookups.locations
        },
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
        pageReady() {
            return this.loaded && this.builds_ready
        },
        start_date() {
            return this.$date(this.lead.start_date).format('dddd, DD/MM/YYYY')
        },
        end_date() {
            return this.$date(this.lead.end_date).format('dddd, DD/MM/YYYY')
        },
        people() {
            return this.lead.people + ' persons'
        },
        selected_location() {
            return this.getLocations.find((location) => location.id === this.quote_location_id) || null
        },
        // Each entry describes one build step's content: its display name, and the
        // supplier type group(s) it covers. Advanced mode has one group per step;
        // Simple mode groups related types (e.g. Day + Night Activity) into one step.
        step_configs() {
            const group = (build_index) => ({
                label: this.build_index_labels[build_index],
                build_index,
                supplier_type: this.build_index_supplier_types[build_index],
            })
            if (this.mode === 'advanced') {
                return [1, 2, 3, 4, 5, 6, 7].map((build_index) => ({
                    service_name: this.build_index_labels[build_index],
                    type_groups: [group(build_index)],
                }))
            }
            return [
                { service_name: 'Activities', type_groups: [group(1), group(2)] },
                { service_name: 'Food', type_groups: [group(3), group(4), group(5)] },
                { service_name: 'Additional', type_groups: [group(6), group(7)] },
            ]
        },
        steps() {
            return ['Accommodation', ...this.step_configs.map((c) => c.service_name), 'Review', 'Complete']
        },
        // Every non-accommodation booking type, in canonical order, for the quick-edit
        // type selector on each product row — always the full set of 7 regardless of
        // mode, so agents can reassign a product to a type that isn't in the current step.
        booking_types() {
            return this.build_index_supplier_types
                .map((supplier_type, i) => ({ id: supplier_type, name: this.build_index_labels[i] }))
                .filter((type) => type.id !== this.build_index_supplier_types[0])
        },
        // Maps a supplier_type id to which step (in the current mode) it lives in, so a
        // QuoteBuild instance can tell a product moved out of its own step without asking
        // the parent first, and so the parent knows which step instance to hand it to.
        type_step_lookup() {
            const lookup = {}
            this.step_configs.forEach((cfg) => {
                cfg.type_groups.forEach((group) => {
                    lookup[group.supplier_type] = { build_index: group.build_index, step_label: cfg.service_name, type_label: group.label }
                })
            })
            return lookup
        },
        sidebar_steps() {
            return ['Accommodation', ...this.step_configs.map((c) => c.service_name)]
        },
        total_steps() {
            return this.steps.length
        },
        review_step() {
            return this.total_steps - 1
        },
        edit_builds_by_step() {
            return this.step_configs.map((cfg) => {
                const map = {}
                cfg.type_groups.forEach((group) => {
                    map[group.build_index] = this.builds[group.build_index]
                })
                return map
            })
        },
        // Flattens each step's type groups into one date-sorted list (tie-break by the
        // group's position in type_groups, which already matches canonical type order)
        // so e.g. a Friday night activity shows before a Saturday day activity instead
        // of being grouped after it by type.
        sidebar_builds_by_step() {
            return this.step_configs.map((cfg) => {
                const flattened = []
                cfg.type_groups.forEach((group, group_index) => {
                    (this.builds[group.build_index] || []).forEach((build) => {
                        flattened.push({ label: group.label, group_index, build })
                    })
                })
                return flattened.sort((a, b) => {
                    const a_date = a.build.start_date || ''
                    const b_date = b.build.start_date || ''
                    if (a_date !== b_date) return a_date < b_date ? -1 : 1
                    return a.group_index - b.group_index
                })
            })
        },
    },
    watch: {
        mode() {
            if (this.edit_quote_id) {
                this.open_panels = this.sidebar_steps.map((_, i) => i)
                this.selected_step = this.review_step
            }
            else {
                this.selected_step = 1
                this.open_panels = [0]
            }
        },
        quote_location_id() {
            if (!this.edit_quote_id && this.selected_location && this.lead.event_type) {
                const formattedDate = this.$date(this.lead.start_date).format('DD/MM/YYYY')
                this.quote_name = `${this.selected_location.name} ${this.lead.event_type.name} Party ${formattedDate}`
            }
        }
    },
    methods: {
        ...mapActions({
            setPageName: 'pageNameStore/setPageNameAction',
        }),
        async emailQuote() {
            const response = await this.$axios.post('admin/quotes/send_email_quote', this.created_quote)
            const result = response.data
            if (result.response == true) {
                this.$toast.success(result.message, { timeout: 2000, icon: true })
            }
            else {
                this.$toast.error(result.message)
            }
        },
        async getLeadData() {
            this.lead.id = this.$route.params.lead_id ?? this.lead_id
            const response = await this.$axios.get(`admin/leads/get_lead/${this.lead.id}`)
            const lead_data = response.data?.data
            if (lead_data) {
                this.lead = lead_data
                this.quote_location_id = this.lead.location_id
                this.date_range = this.getDateRange()
                this.groupsize = this.lead.people
                if (!this.edit_quote_id && this.lead.location && this.lead.event_type) {
                    const formattedDate = this.$date(this.lead.start_date).format('DD/MM/YYYY')
                    this.quote_name = `${this.lead.location.name} ${this.lead.event_type.name} Party ${formattedDate}`
                }
            }
        },
        async getEditData() {
            this.edit_quote_id = this.$route.params.quote_id ?? this.quote_id
            if (this.edit_quote_id) {
                this.open_panels = this.sidebar_steps.map((_, i) => i)
                this.selected_step = this.review_step
                this.setPageName('Edit Custom Quote')
                const response = await this.$axios.get(`admin/quotes/get_quote/${this.edit_quote_id}`)
                this.quote_to_edit = response.data?.data
                if (!this.quote_to_edit) {
                    this.$toast.error('Unable to load this quote.')
                    this.builds_ready = true
                    return
                }
                this.quote_name = this.quote_to_edit.name
                document.title = `Quote - ${this.quote_to_edit.name} - GGB`
                this.groupsize = this.quote_to_edit.groupsize
                this.min_groupsize = this.quote_to_edit.min_groupsize
                this.quote_location_id = this.quote_to_edit.location_id ?? this.quote_location_id
            }
            else {
                this.setPageName('Create Custom Quote')
                this.builds_ready = true
            }
        },
        // Runs after getSuppliers() so Accommodation/QuoteBuild can resolve each build's
        // supplier from the already-loaded location list instead of fetching it individually.
        populateEditBuilds() {
            if (!this.quote_to_edit) {
                this.builds_ready = true
                return
            }
            this.placeBuilds(this.quote_to_edit.builds)
            this.builds_ready = true
        },
        // Puts saved-style builds ({ type_id, start_date, end_date, supplier, option }) into the
        // editor's per-step `builds` buckets. Used for a saved quote and for an AI Assistant draft.
        placeBuilds(list) {
            let grouped_builds = this.groupBy(list, 'type_id')
            grouped_builds.forEach((type, index) => {
                // `index` here is the build's real persisted type_id. Its bucket is the type's
                // position in build_index_supplier_types (the canonical step order), plus one.
                const supplier_type = this.build_index_supplier_types.indexOf(index) + 1
                // A type the builder has no step for: leave it out rather than corrupt a bucket
                if (supplier_type === 0) return
                if (this.builds[supplier_type - 1] == null) {
                    this.$set(this.builds, supplier_type - 1, [])
                }
                type.forEach((build) => {
                    const supplier_id = build.supplier ? build.supplier.id : null
                    const existing_index = this.builds[supplier_type - 1].findIndex((b) => {
                        return b.start_date == build.start_date && (b.supplier ? b.supplier.id : null) == supplier_id
                    })
                    // Stamp the option with its actual persisted type (the type_id this
                    // group was bucketed by) so later re-buckets (e.g. QuoteBuild.vue's
                    // getSupplier() -> saveWithoutScroll() -> buildMap()) preserve it
                    // instead of falling back to a supplier-level guess.
                    const option_with_type = build.option ? { ...build.option, resolved_type_id: index } : build.option
                    if (existing_index == -1) {
                        let edit_build = {
                            start_date: build.start_date,
                            end_date: build.end_date,
                            supplier: build.supplier,
                            options: [option_with_type],
                        }
                        this.builds[supplier_type - 1].push(edit_build)
                    }
                    else {
                        this.builds[supplier_type - 1][existing_index].options.push(option_with_type)
                    }
                })
            })
        },
        // An AI Assistant draft (draft_quote, held in the ai_chat store) for this lead / quote:
        // load it into the editor and open the Review tab. Nothing is saved here: the user checks
        // it and presses Create or Update. Called on mount and by the bubble when already here.
        async loadAiQuoteDraft() {
            const draft = this.$store.state.ai_chat.quote_draft
            if (!draft || !this.lead || String(draft.lead_id) !== String(this.lead.id)) return
            if (String(draft.quote_id || '') !== String(this.edit_quote_id || '')) return
            this.$store.commit('ai_chat/set_quote_draft', null)
            // Older than an hour (e.g. left in the persisted store): ignore it
            if (!draft.at || Date.now() - draft.at > 3600000) return

            if (draft.location_id && draft.location_id !== this.quote_location_id) {
                this.quote_location_id = draft.location_id
                await this.getSuppliers()
            }
            // Supplier and product objects as the editor uses them: the destination's list, else
            // the ones already on this quote
            const current = []
            this.builds.forEach((bucket) => (bucket || []).forEach((b) => b && b.supplier && current.push(b.supplier)))
            const missing = []
            const list = []
            draft.builds.forEach((b) => {
                const supplier = this.all_suppliers.find((s) => s.id === b.supplier_id) || current.find((s) => s.id === b.supplier_id)
                const option = supplier && (supplier.products || []).find((p) => p.id === b.product_id)
                if (!supplier || !option) {
                    missing.push(b.product_id)
                    return
                }
                list.push({ type_id: b.type_id, start_date: b.start_date, end_date: b.end_date, supplier, option })
            })

            this.builds = []
            this.placeBuilds(list)
            if (draft.name) this.quote_name = draft.name
            if (draft.groupsize) this.groupsize = draft.groupsize
            // Rebuild the step components from the new builds, then show Review with every panel open
            this.draft_key++
            this.open_panels = this.sidebar_steps.map((_, i) => i)
            this.selected_step = this.review_step
            this.$nextTick(() => {
                const review = this.$refs.review
                if (review) {
                    Object.assign(review.details, {
                        discount_type: draft.discount_type || 'amount',
                        discount: draft.discount || 0,
                        surcharge_type: draft.surcharge_type || 'amount',
                        surcharge: draft.surcharge || 0,
                    })
                }
            })
            if (missing.length) {
                this.$toast.warning(`The assistant's draft has ${missing.length} service(s) this editor could not load; add them by hand.`)
            }
            this.$toast.info(`Draft from the AI Assistant loaded. Check it, then press ${this.edit_quote_id ? 'Update' : 'Create'} to save.`, { timeout: 6000 })
        },
        groupBy(array, key) {
            return array.reduce((result, currentValue) => {
                (result[currentValue[key]] = result[currentValue[key]] || []).push(
                    currentValue,
                )
                return result
            }, [])
        },
        getDateRange() {
            let number_of_days = -1
            return [...Array(parseInt(this.lead.duration + 1))].map(() => {
                const event_date = new Date(this.lead.start_date)
                number_of_days += 1
                event_date.setDate(event_date.getDate() + number_of_days)
                return event_date.toISOString().substr(0, 10)
            })
        },
        backToLeads() {
            this.$router.push({ name: 'EditLeads', params: { id: this.lead.id } })
        },
        closeSupplierChanges() {
            this.supplier_changes = null
            if (this.leave_after_supplier_changes) {
                this.leave_after_supplier_changes = false
                this.backToLeads()
            }
        },
        changeStep(index) {
            if (!this.loading_location_change) {
                const currentIndex = this.selected_step - 1
                if (currentIndex === 0 && this.$refs.accommodation?.[0]) {
                    this.$refs.accommodation[0].triggerSave()
                } else if (currentIndex >= 1 && currentIndex <= this.step_configs.length && this.$refs.quoteBuild?.[currentIndex - 1]) {
                    this.$refs.quoteBuild[currentIndex - 1].triggerSave()
                }
            }
            this.selected_step = index + 1
            if (index == this.total_steps - 1)
                return
            if (index > this.step_configs.length) {
                this.scroll(0)
            }
            else {
                this.scroll(index)
                this.open_panels.indexOf(index) === -1 ? this.open_panels.push(index) : null
            }
        },
        scroll(index) {
            setTimeout(() => {
                this.$vuetify.goTo('#panel' + index, { offset: 0, container: '.custom-expansion-panels' });
            }, 500)
        },
        skip() {
            this.changeStep(this.selected_step)
        },
        back() {
            this.changeStep(this.selected_step - 2)
        },
        save(data, step) {
            this.applyBuildData(data, step)
            this.changeStep(this.selected_step)
        },
        saveWithoutScroll(data, step) {
            this.applyBuildData(data, step)
        },
        // Accommodation emits a plain array for its single build_index (0).
        // QuoteBuild always emits a map of { build_index: builds[] } — a single
        // entry in Advanced mode, or multiple entries when steps are grouped in Simple mode.
        applyBuildData(data, step) {
            if (Array.isArray(data)) {
                this.$set(this.builds, step, data)
            }
            else if (data) {
                Object.keys(data).forEach((build_index) => {
                    this.$set(this.builds, build_index, data[build_index])
                })
            }
        },
        // The Minimum Group Size field as a whole number, or null when it's empty (no minimum)
        minGroupsizeValue() {
            const value = Number(this.min_groupsize)
            return Number.isInteger(value) && value > 0 ? value : null
        },
        // false (with a message) when something was typed that can't be saved as a minimum
        checkMinGroupsize() {
            const empty = this.min_groupsize === null || this.min_groupsize === undefined || String(this.min_groupsize).trim() === ''
            if (!empty && this.minGroupsizeValue() === null) {
                this.$toast.error('Minimum group size must be a whole number of 1 or more, or left empty')
                return false
            }
            return true
        },
        async finish(data) {
            if (this.quote_name == null || this.quote_name == '') {
                this.$toast.error('Please enter a quote name')
                return
            }
            if (!this.checkMinGroupsize()) return
            let payload = {
                company_id: this.get_selected_company.id,
                lead_id: this.lead.id,
                location_id: this.quote_location_id,
                name: this.quote_name,
                builds: this.builds,
                date_range: this.date_range,
                type: data.type,
                groupsize: this.groupsize,
                min_groupsize: this.minGroupsizeValue(),
                subtotal: data.subtotal,
                discount_type: data.discount_type,
                discount: data.discount,
                surcharge_type: data.surcharge_type,
                surcharge: data.surcharge,
                total: data.total,
            }
            const response = await this.$axios.post('admin/quotes/create_custom_quote', payload)
            const result = response.data
            if (result.response == true) {
                this.$toast.success(result.message, { timeout: 2000, icon: true })
                // Full page load straight onto the edit URL. Doing $router.push() then
                // window.location.reload() raced: push is async (route guards), so the reload
                // often hit the still-current create URL and showed a blank new quote.
                const edit_route = this.$router.resolve({ name: 'EditCustomQuote', params: { lead_id: this.lead.id, quote_id: result.data.id } })
                window.location.assign(edit_route.href)
            }
            else {
                this.$toast.error(result.message)
            }
        },
        async update(data) {
            if (this.quote_name == null || this.quote_name == '') {
                this.$toast.error('Please enter a quote name')
                return
            }
            if (!this.checkMinGroupsize()) return
            let payload = {
                id: this.edit_quote_id,
                company_id: this.get_selected_company.id,
                lead_id: this.lead.id,
                location_id: this.quote_location_id,
                name: this.quote_name,
                builds: this.builds,
                date_range: this.date_range,
                type: data.type,
                groupsize: this.groupsize,
                min_groupsize: this.minGroupsizeValue(),
                subtotal: data.subtotal,
                discount_type: data.discount_type,
                discount: data.discount,
                surcharge_type: data.surcharge_type,
                surcharge: data.surcharge,
                total: data.total
            }
            // Removing or replacing services that other packages (variants) also book: ask
            // whether to change them there too.
            const variant_changes = await this.askVariantChanges(payload)
            if (variant_changes === null) return
            payload.variant_changes = variant_changes

            const response = await this.$axios.post(`admin/quotes/update_custom_quote/${payload.id}`, payload)
            const result = response.data
            if (result.response == true) {
                this.$toast.success(result.message, { timeout: 2000, icon: true })
                this.changeStep(this.selected_step)
                this.supplier_changes = result.supplier_changes || null
                this.organiser_prompt = result.organiser_paid_at_old_price || null
            }
            else {
                this.$toast.error(result.message)
            }
        },
        // [] when nothing shared changes, the agent's choices, or null if they cancelled.
        async askVariantChanges(payload) {
            let changes = []
            try {
                const { data } = await this.$axios.post(`admin/quotes/preview_variant_changes/${payload.id}`, { builds: payload.builds })
                changes = data.response ? data.data : []
            } catch (error) {
                changes = []
            }
            if (!changes.length) return []
            return this.$refs.variantChanges.ask(changes)
        },
        deleteQuoteDialog() {
            this.delete_quote_dialog = true
        },
        closeDeleteQuoteDialog() {
            this.delete_quote_dialog = false
        },
        async deleteQuote() {
            try {
                const response = await this.$axios.delete(`admin/quotes/delete_quote_with_builds/${this.edit_quote_id}/${this.get_selected_company.id}/${this.lead.id}`)
                const result = response.data
                if (result.response == true) {
                    this.$toast.success(result.message, { timeout: 2000, icon: true })
                    if (result.supplier_changes && result.supplier_changes.suppliers) {
                        // Leave once the cancellation emails are sent or skipped.
                        this.leave_after_supplier_changes = true
                        this.supplier_changes = result.supplier_changes
                    } else {
                        this.backToLeads()
                    }
                }
                else {
                    this.$toast.error(result.message)
                }
            } catch (error) {
                // e.g. the API refuses to delete a quote that has payments against it
                this.$toast.error(error.response?.data?.message || 'Failed to delete quote')
            }
        },
        // A product on a currently-selected build had its booking type changed to
        // something outside its own step's type_groups (e.g. Dinner -> Day Activity).
        // QuoteBuild.vue already removed it from its own local state; hand it to the
        // destination step's live instance so it shows up there immediately, without
        // waiting for a save/reload round trip.
        onMoveOption({ target_supplier_type, supplier, start_date, end_date, option }) {
            const step_index = this.step_configs.findIndex((cfg) => cfg.type_groups.some((g) => g.supplier_type === target_supplier_type))
            if (step_index === -1) return
            this.$nextTick(() => {
                const instance = this.$refs.quoteBuild && this.$refs.quoteBuild[step_index]
                if (instance && instance.receiveMovedOption) {
                    instance.receiveMovedOption({ supplier, start_date, end_date, option })
                }
            })
        },
        onLocationChange() {
            this.builds = []
            this.getSuppliers()
        },
        // Called by the AI Assistant after it changes data (e.g. a supplier's prices): reload the
        // destination's suppliers, keeping the services and edits already in the editor
        aiRefresh() {
            return this.getSuppliers()
        },
        async getSuppliers() {
            // A lead can have no location set; skip the request (it would hit the API as
            // ".../null" and 500) and let the user pick a location, which refetches.
            if (!this.quote_location_id) {
                this.all_suppliers = []
                this.loaded = true
                this.loading_location_change = false
                return
            }
            this.loading_location_change = true
            const response = await this.$axios.get(`admin/suppliers/get_suppliers_by_location_for_quotes/${this.get_selected_company.id}/${this.quote_location_id}`)
            const result = response.data
            if (result.response == true) {
                this.all_suppliers = result.data
                this.loaded = true
            }
            else {
                this.$toast.error(result.message)
            }
            this.loading_location_change = false
        },
        getSuppliersByType(index) {
            return this.all_suppliers.filter((item) => {
                return item.service_type_id === index
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.card-format {
    padding: 24px;
    border-radius: 20px !important;

    .card-footer-format {
        border-top: 1px solid #E9E9E9;
        background-color: #E9E9E9;
    }
}

.card-footer-format {
    .pagination-font-format {
        font-family: 'Work Sans';
        font-size: 14px;
    }

    .bg-color-white {
        background-color: white;
    }
}

.v-input__slot {
    background: white !important;
}

.v-stepper__header {
    box-shadow: none !important;
}

.accom-price {
    color: #FAAF3A;
    font-size: 36px;
    font-weight: 600;
}

.custom-title {
    font-family: Manrope;
    font-size: 14px !important;
    color: #3988AA;
    font-weight: 600;
}

.stepper-hint {
    font-family: Manrope;
    font-size: 13px;
    color: #3988AA;
    text-align: center;
}

:deep(.mode-toggle) {
    border: 1px solid #AFCFDC;
    border-radius: 8px;
    overflow: hidden;

    .v-btn {
        font-family: Manrope;
        font-weight: 600;
        text-transform: none;
        color: #3988AA;
    }

    .v-btn--active {
        background-color: #3988AA !important;
        color: white !important;
    }
}

.supplier-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: #000000;
}

.supplier-dates {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    color: #000000;
}

.sublabel {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 5px;
}

.details {
    font-family: Manrope;
    font-size: 10px !important;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    padding: 0px !important;
}

.description {
    color: #7D7D7D;
    font-family: Manrope;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.summary {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 20px;
}

.back-to-leads {
    color: var(--Blue-Linear, #3988AA);
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: none;
}

:deep(.custom-text-field) {
    label {
        top: 10px !important;
    }

    .v-text-field__slot {
        top: 6px;
    }

    .v-label--active {
        transform: translateY(-20px) scale(0.75) !important;
    }

    legend {
        display: none;
    }

    fieldset {
        border-color: #D3D3D3 !important;
    }

    input {
        color: #727272;
        font-family: Manrope;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
        border: none !important;
    }
}

:deep(.custom-text-field-active) {
    input {
        color: #101010;
    }
}

:deep(.custom-stepper-header) {
    display: contents;
    flex-wrap: inherit;

    .v-stepper__step--inactive span {
        background: #AFCFDC !important;
    }
}

.custom-step-active {
    color: var(--Blue-Linear, #3988AA);
    text-align: center;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-shadow: none !important;
}

.custom-step-inactive {
    color: #AFCFDC;
    text-align: center;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-shadow: none !important;
}

.custom-expansion-panels {
    max-height: 800px;
    overflow-y: scroll;
    padding-right: 9px;
    padding-bottom: 400px;
}

.custom-expansion-panel::before {
    box-shadow: none !important;
}

.custom-expansion-panel::after {
    border-top: none !important;
}

.v-expansion-panel--active,
.v-expansion-panel--active+.v-expansion-panel {
    margin-top: 0px !important;
}

.v-expansion-panel-header--active {
    border-radius: 10px 10px 0px 0px !important;
    min-height: 0px !important;
}

:deep(.custom-expansion-header) {
    border-radius: 10px;
    background: var(--Blue-Linear, #3988AA);
    color: var(--icon-color, #FFF);
    font-family: Manrope;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;

    .v-icon {
        color: white !important;
    }
}

.custom-expansion-panel-content {
    font-family: Manrope;
    padding: 30px;
    border-radius: 0px 0px 10px 10px;
    border: 1px solid var(--Border, #E9E9E9);
    background: var(--icon-color, #FFF);
    box-shadow: 5px 5px 13px 0px rgba(240, 240, 240, 0.90), -5px -5px 10px 0px rgba(255, 255, 255, 0.90), 5px -5px 10px 0px rgba(240, 240, 240, 0.20), -5px 5px 10px 0px rgba(240, 240, 240, 0.20);
}

.v-expansion-panel-content__wrap {
    padding: 0px !important;
}

::-webkit-scrollbar {
    width: 7px;
    background: white;
}

::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #D9D9D9;
    color: #D9D9D9;
    height: 226px;
}
</style>